export default __webpack_public_path__ + "static/media/card-img.f172dcda.png";